// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "platform-host/" + chunkId + "-" + {2313: "fde0f5e913f1c234",2470: "9ba0fdf65642c890",25: "609af0bf725f25ef",425: "9efb169b998679ab",}[chunkId] + ".css"
}